import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import CheckCircle from 'svg/check-circle.svg';
import styles from './MobileCountryCodeFormPartial.pcss';
import CountryFlagImage from './CountryFlagImage';
const CountryRow = ({ value, label, isSelected, onSelectCountryRow })=>{
    const onClick = ()=>onSelectCountryRow(value);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.countryRow, {
            [styles['countryRow--selected']]: isSelected
        }),
        onClick: onClick,
        children: [
            isSelected && /*#__PURE__*/ _jsx(CheckCircle, {
                className: styles.countryRow__checkIcon
            }),
            /*#__PURE__*/ _jsx(CountryFlagImage, {
                countryCode: value,
                className: styles.countryRow__flag
            }),
            label
        ]
    }, value));
};
export default CountryRow;
